// 职业探索
import React from 'react'

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';

import CareerVideo from '../component/CareerVideo';
import SceneChat from '../component/SceneChat';

let filePath = Config.getFilePath();

class CareerExploreAI extends React.Component 
{
    constructor( props )
    {
        super(props);

        let userInfo = sessionStorage.getItem("_user_info_");

        let { item } = this.props.location?.state;

        if( userInfo )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            item:item,
            basePath: Config.getBasePath(),
            sourcePath: Config.getSourcePath(),
            userInfo: userInfo || {},
            videoData:[]
        }
    }

    componentDidMount()
    {
        const { item } = this.state;

        if( item && item.sessionId )
        {
            this.loadSession( item )
        }
        else
        {
            this.createSession()
        }
    }

    goBack = () => {
        this.props.history.push({pathname:"/home/career-explore"});
    }

    /**
    * 创建会话
    */
    createSession = ( callback ) => {

        const { scene } = this.props;

        const { basePath } = this.state;

        let params = {
            scene: scene || "resume",
            title: "新对话",
            type: "02"
        }

        const onCreateSession = (result, backParams) => {

            if( result.status===0 )
            {
                this.setState({sessionId:result.result}, () => {

                   
                });
            }
        }

        WidgetAjax.ajax({url: basePath + "/session/create", params:params, callback:onCreateSession}, this.props);
    }

    loadSession = ( item ) => {

        const { scene } = this.props;

        const { basePath } = this.state;

        let params = {
            scene: scene || "resume",
            title: "新对话",
            type: "02"
        }

        const onCreateSession = (result, backParams) => {

            if( result.status===0 )
            {
                this.setState({sessionId:result.result});
            }
        }

        WidgetAjax.ajax({url: basePath + "/session/create", params:params, callback:onCreateSession}, this.props);
    }

    notify = ( item ) => {

    }

    recommendNotify = ( item ) => {

    }

    videoNotify = ( item ) => {

    }

    render()
    {
        const { item={}, sourcePath, videoData, videoTotal, sessionId, sessionTitle, role="ai",  scene="", chatContent=undefined, } = this.state;
        
        return (
            <div className="sf-page" component-data="career-planning-chat">
                <div className='sf-career-chat-top'>
                    <div className='sf-career-top-body sf-padding-50'>
                        <div className='sf-career-explore-ai'>
                            <div className='sf-career-title-welcome'>
                                <img onClick={this.goBack} src={require('./../../img/' + sourcePath + '/career/back.svg')} alt=""></img>
                                <div className='sf-vertical-line'></div>
                                <div className='sf-welcome-right'>
                                    <span> {item.title} </span>
                                </div>
                            </div>

                            <div className='sf-career-explore-ai-chat'>
                                <SceneChat sessionId={sessionId} sessionTitle={sessionTitle} history={this.props.history} role={role} 
                                    chatContent={chatContent} scrollRef={this.scrollRef} notify={this.notify} scene={scene} title={item.title} ></SceneChat>
                            </div>

                        </div>

                        <div className='sf-career-explore-ai-right'>
                            
                            <div className='sf-career-explore-ai-oth'>
                                <div className='sf-career-explore-ai-oth-title'>
                                    <div className='sf-vertical-line'></div>
                                    <span>猜您还想了解</span>
                                </div>

                                <div className='sf-career-explore-ai-oth-body'>
                                    <CareerVideo data={videoData} total={videoTotal} notify={ this.videoNotify} > </CareerVideo>
                                </div>
                            </div>

                            <div className='sf-career-explore-ai-oth'>
                                <div className='sf-career-explore-ai-oth-title'>
                                    <div className='sf-vertical-line'></div>
                                    <span>今日推荐微视</span>
                                </div>

                                <div className='sf-career-explore-ai-oth-body'>
                                    <CareerVideo data={videoData} total={videoTotal} notify={ this.videoNotify} > </CareerVideo>
                                </div>
                            </div>

                            <div className='sf-career-explore-ai-oth'>
                                <div className='sf-career-explore-ai-oth-title'>
                                    <div className='sf-vertical-line'></div>
                                    <span>了解自己的职业能力</span>
                                </div>

                                <div className='sf-career-explore-ai-oth-body'>
                                    <CareerVideo data={videoData} total={videoTotal} notify={ this.videoNotify} > </CareerVideo>
                                </div>
                            </div>

                            <div className='sf-career-explore-ai-oth'>
                                <div className='sf-career-explore-ai-oth-title'>
                                    <div className='sf-vertical-line'></div>
                                    <span>近似职业</span>
                                </div>

                                <div className='sf-career-explore-ai-oth-body'>
                                    <CareerVideo data={videoData} total={videoTotal} notify={ this.videoNotify} > </CareerVideo>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                   
                </div>
                
            </div>
        )
    }
}
export default CareerExploreAI;